import { Home, UserCircle2, TrendingUp, HeartPulse, Sparkles, Brain, Activity, Dumbbell, Video, BookOpen, CalendarCheck, Stethoscope, FileBarChart2, Users, CreditCard } from "lucide-react";

// Player navigation grouped into 4 easy-to-understand sections.
export const PLAYER_GROUPS = [
  { id: "home", to: "/dashboard", icon: Home, fr: "Accueil", en: "Home", items: [] },
  {
    id: "twin", icon: UserCircle2, fr: "Mon Jumeau", en: "My Twin",
    frDesc: "Ton avatar IA et ton coach personnel", enDesc: "Your AI avatar and personal coach",
    items: [
      { to: "/avatar", icon: Sparkles, fr: "Avatar IA", en: "AI Avatar", frDesc: "Crée ton double en 1 photo", enDesc: "Create your twin from 1 photo" },
      { to: "/coach", icon: Brain, fr: "Coach IA", en: "AI Coach", frDesc: "Pose tes questions, reçois un plan", enDesc: "Ask anything, get a plan" },
    ],
  },
  {
    id: "progress", icon: TrendingUp, fr: "Progression", en: "Progress",
    frDesc: "Tes stats, programmes, vidéos et photos", enDesc: "Your stats, programs, videos and photos",
    items: [
      { to: "/stats", icon: Activity, fr: "Stats", en: "Stats", frDesc: "Poids, vitesse, VO2…", enDesc: "Weight, speed, VO2…" },
      { to: "/programs", icon: Dumbbell, fr: "Programmes", en: "Programs", frDesc: "Entraînements IA sur mesure", enDesc: "Tailored AI workouts" },
      { to: "/video", icon: Video, fr: "Vidéo", en: "Video", frDesc: "L'IA analyse ton clip", enDesc: "AI watches your clip" },
      { to: "/journal", icon: BookOpen, fr: "Journal", en: "Journal", frDesc: "Photos avant / après", enDesc: "Before / after photos" },
    ],
  },
  {
    id: "health", icon: HeartPulse, fr: "Santé", en: "Health",
    frDesc: "Comment tu te sens, blessures et bilan hebdo", enDesc: "How you feel, injuries and weekly report",
    items: [
      { to: "/daily", icon: CalendarCheck, fr: "Suivi quotidien", en: "Daily Log", frDesc: "2 minutes après chaque séance", enDesc: "2 minutes after each session" },
      { to: "/medical", icon: Stethoscope, fr: "Carte médicale", en: "Medical Map", frDesc: "Blessures et protocoles", enDesc: "Injuries and protocols" },
      { to: "/report", icon: FileBarChart2, fr: "Rapport hebdo", en: "Weekly Report", frDesc: "Le bilan IA du dimanche", enDesc: "Sunday AI summary" },
    ],
  },
];

export const PLAYER_ACCOUNT = [
  { to: "/team", icon: Users, fr: "Mon équipe / club", en: "My team / club" },
  { to: "/billing", icon: CreditCard, fr: "Abonnement", en: "Subscription" },
];

export const groupForPath = (pathname) => PLAYER_GROUPS.find((g) => g.to === pathname || g.items.some((i) => pathname.startsWith(i.to)));
